import { FeatureFlagOptions, FeatureFlags } from ".";

export const defaultFeatureFlags: FeatureFlags = {
  WALLET: { treatment: "off", config: null },
  ADD_VEHICLE: { treatment: "base", config: null },
  REMOVE_VEHICLE: { treatment: "off", config: { max_vehicle_count: "10" } },
  SETTINGS_MFA_FOR_ALL: { treatment: "off", config: null },
  SELL_VEHICLE: { treatment: "off", config: null },
};

/** An array of all supported feature flags. */
export const featureFlagKeys = Object.keys(defaultFeatureFlags);

/**
 * Convert a featureFlags object into an array of strings formatted as "key:value"
 * ex: { INSURANCE: "new"} => ["INSURANCE:new"]
 */
export const formatFeatureFlagsForTracking = (
  featureFlags: FeatureFlags
): string[] => {
  return Object.entries(featureFlags).map(
    ([key, value]) => `${key}:${value.treatment}`
  );
};

export const defaultTestFeatureFlags = {
  WALLET: { treatment: "off", config: null },
  ADD_VEHICLE: { treatment: "base", config: null },
  REMOVE_VEHICLE: { treatment: "on", config: { max_vehicle_count: "10" } },
  SETTINGS_MFA_FOR_ALL: { treatment: "on", config: null },
  SELL_VEHICLE: { treatment: "on", config: null },
} as const;

const WalletFeatureFlags = ["off", "on"];
const AddVehicleFeatureFlags = ["base", "new"];
const RemoveVehicleFeatureFlags = ["off", "on"];
const SettingsMfaForAllFeatureFlags = ["off", "on"];
const SellVehicleFeatureFlags = ["off", "on"];

export const defaultWalletOptions: FeatureFlagOptions = {
  values: WalletFeatureFlags,
  defaultValue: "off",
  config: null,
} as const;

export const defaultAddVehicleOptions: FeatureFlagOptions = {
  values: AddVehicleFeatureFlags,
  defaultValue: "base",
  config: null,
} as const;

export const defaultRemoveVehicleOptions: FeatureFlagOptions = {
  values: RemoveVehicleFeatureFlags,
  defaultValue: "off",
  config: { max_vehicle_count: "10" },
} as const;

export const defaultSettingsMfaForAllOptions: FeatureFlagOptions = {
  values: SettingsMfaForAllFeatureFlags,
  defaultValue: "off",
  config: null,
} as const;

export const defaultSellVehicleOptions: FeatureFlagOptions = {
  values: SellVehicleFeatureFlags,
  defaultValue: "off",
  config: null,
} as const;
